"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _shared = require("@widget-editor/shared");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var StyledButton = _styledComponents["default"].button.withConfig({
  displayName: "toggle-order__StyledButton",
  componentId: "j60o7-0"
})(["border:1px solid rgba(202,204,208,0.85);display:flex;align-items:center;justify-content:center;padding:13px 0;cursor:pointer;border-radius:5px;outline:none;&:focus{border:1px solid #c32d7b;}&:hover{color:#c32d7b;svg{transition:all 0.4s;fill:#c32d7b;}}", " svg{width:14px;height:14px;fill:#c32d7b;}"], function (props) {
  return props.order && props.order === "asc" && (0, _styledComponents.css)(["svg{transition:all 0.4s;transform:rotate(180deg);}"]);
});

var ToggleOrder = function ToggleOrder(_ref) {
  var order = _ref.order,
      options = _ref.options,
      onChange = _ref.onChange;

  var handleChange = function handleChange() {
    var findOposite = options.filter(function (o) {
      return o.value !== order.value;
    })[0];
    onChange(findOposite);
  };

  return _react["default"].createElement(StyledButton, {
    order: order.value,
    type: "button",
    onClick: handleChange
  }, _react["default"].createElement(_shared.ArrowIcon, null));
};

var _default = ToggleOrder;
exports["default"] = _default;